import PhishingCampaignDetails from './PhishingCampaignDetails';

export default PhishingCampaignDetails;
